import { useEffect, useCallback, useMemo } from "react";
import { u as useUrlQueryParam } from "./useUrlQueryParam-CjUhdvgb.js";
import arLocale from "date-fns/locale/ar-SA";
import enUsLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";
import faIrLocale from "date-fns/locale/fa-IR";
import frLocale from "date-fns/locale/fr";
import hiLocale from "date-fns/locale/hi";
import htLocale from "date-fns/locale/ht";
import huLocale from "date-fns/locale/hu";
import koLocale from "date-fns/locale/ko";
import nlLocale from "date-fns/locale/nl";
import plLocale from "date-fns/locale/pl";
import ptLocale from "date-fns/locale/pt";
import ruLocale from "date-fns/locale/ru";
import ukLocale from "date-fns/locale/uk";
import viLocale from "date-fns/locale/vi";
import zhCnLocale from "date-fns/locale/zh-CN";
import zhTwLocale from "date-fns/locale/zh-TW";
import buildFormatLongFn from "date-fns/locale/_lib/buildFormatLongFn";
import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";
import buildLocalizeFn$1 from "date-fns/locale/_lib/buildLocalizeFn/index";
import { u as useCookiesContext } from "./context-BLGMb4ty.js";
const dateFormats$4 = {
  full: "EEEE ፣d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
const timeFormats$3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$5 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong$5 = {
  date: buildFormatLongFn({
    formats: dateFormats$4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$5,
    defaultWidth: "full"
  })
};
const defaultMonthValues$4 = [
  "ጃንዩወሪ",
  "ፌብሩወሪ",
  "ማርች",
  "ኤፕሪል",
  "ሜይ",
  "ጁን",
  "ጁላይ",
  "ኦገስት",
  "ሴፕቴምበር",
  "ኦክቶበር",
  "ኖቬምበር",
  "ዲሴምበር"
];
const abbreviatedMonthValues$1 = [
  "ጃንዩ",
  "ፌብሩ",
  "ማርች",
  "ኤፕሪ",
  "ሜይ",
  "ጁን",
  "ጁላይ",
  "ኦገስ",
  "ሴፕቴ",
  "ኦክቶ",
  "ኖቬም",
  "ዲሴም"
];
const monthValues$5 = {
  narrow: abbreviatedMonthValues$1,
  abbreviated: abbreviatedMonthValues$1,
  wide: defaultMonthValues$4
};
const defaultDayValues$4 = ["እሑድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
const abbreviatedDayValues$1 = ["እሑድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
const dayValues$5 = {
  narrow: abbreviatedDayValues$1,
  short: abbreviatedDayValues$1,
  abbreviated: abbreviatedDayValues$1,
  wide: defaultDayValues$4
};
const defaultDayPeriodValues$5 = {
  am: "ጥዋት",
  pm: "ከሰዓት",
  midnight: "እኩለ ሌሊት",
  noon: "ቀትር",
  morning: "ጥዋት1",
  afternoon: "ከሰዓት በኋላ",
  evening: "ማታ",
  night: "ሌሊት"
};
const abbreviatedDayPeriodValues$1 = {
  ...defaultDayPeriodValues$5,
  am: "ጥዋት",
  pm: "ከሰዓት"
};
const dayPeriodValues$5 = {
  narrow: abbreviatedDayPeriodValues$1,
  abbreviated: abbreviatedDayPeriodValues$1,
  wide: defaultDayPeriodValues$5
};
const defaultFormattingDayPeriodValues$4 = {
  am: "ጥዋት",
  pm: "ከሰዓት",
  midnight: "እኩለ ሌሊት",
  noon: "ቀትር",
  morning: "ጥዋት1",
  afternoon: "ከሰዓት በኋላ",
  evening: "ማታ",
  night: "ሌሊት"
};
const abbreviatedFormattingDayPeriodValues$1 = {
  ...defaultFormattingDayPeriodValues$4,
  am: "ጥዋት",
  pm: "ከሰዓት"
};
const formattingDayPeriodValues$4 = {
  narrow: abbreviatedFormattingDayPeriodValues$1,
  abbreviated: abbreviatedFormattingDayPeriodValues$1,
  wide: defaultFormattingDayPeriodValues$4
};
const localize$5 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$5,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$5,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$5,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$4,
    defaultFormattingWidth: "wide"
  })
};
const amLocale = {
  code: "am",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$5,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$5,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateTimeFormats$4 = {
  full: "{{date}} 'sa' {{time}}",
  long: "{{date}} 'sa' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$4 = {
  date: enUsLocale.formatLong.date,
  time: enUsLocale.formatLong.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$4,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$1 = {
  lastWeek: "'noong nakaraang' eeee 'ng' p",
  yesterday: "'kahapon ng' p",
  today: "'ngayong ng' p",
  tomorrow: "'bukas ng' p",
  nextWeek: "'susunod na' eeee 'ng' p",
  other: "P"
};
function formatRelative$1(token) {
  return formatRelativeLocale$1[token];
}
const monthValues$4 = {
  narrow: ["E", "P", "M", "A", "M", "H", "H", "A", "S", "O", "N", "D"],
  abbreviated: ["Ene", "Peb", "Mar", "Abr", "May", "Hun", "Hul", "Ago", "Set", "Okt", "Nob", "Dis"],
  wide: [
    "Enero",
    "Pebrero",
    "Marso",
    "Abril",
    "Mayo",
    "Hunyo",
    "Hulyo",
    "Agosto",
    "Setyembre",
    "Oktubre",
    "Nobyembre",
    "Disyembre"
  ]
};
const shortDayValues = ["Lin", "Lun", "Mar", "Miy", "Huw", "Biy", "Sab"];
const dayValues$4 = {
  narrow: ["Li", "Lu", "Ma", "Mi", "Hu", "Bi", "Sa"],
  short: shortDayValues,
  abbreviated: shortDayValues,
  wide: ["Linggo", "Lunes", "Martes", "Miyerkules", "Huwebes", "Biyernes", "Sabado"]
};
const defaultFormattingDayPeriodValues$3 = {
  am: "AM",
  pm: "PM",
  midnight: "ng hatinggabi",
  noon: "ng tanghali",
  morning: "ng umaga",
  afternoon: "ng hapon",
  evening: "ng gabi",
  night: "ng gabi"
};
const formattingDayPeriodValues$3 = {
  narrow: {
    ...defaultFormattingDayPeriodValues$3,
    am: "A",
    pm: "P"
  },
  abbreviated: defaultFormattingDayPeriodValues$3,
  wide: defaultFormattingDayPeriodValues$3
};
const defaultDayPeriodValues$4 = {
  am: "AM",
  pm: "PM",
  midnight: "hatinggabi",
  noon: "tanghali",
  morning: "umaga",
  afternoon: "hapon",
  evening: "gabi",
  night: "gabi"
};
const dayPeriodValues$4 = {
  narrow: {
    ...defaultDayPeriodValues$4,
    am: "A",
    pm: "P"
  },
  abbreviated: defaultDayPeriodValues$4,
  wide: defaultDayPeriodValues$4
};
function ordinalNumber(dirtyNumber) {
  const number = Number(dirtyNumber);
  return `ika-${number}`;
}
const localize$4 = {
  ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn$1({
    values: monthValues$4,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$4,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: "wide"
  })
};
const filLocale = {
  code: "fil",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$4,
  formatRelative: formatRelative$1,
  localize: localize$4,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const dateFormats$3 = {
  full: "EEEE, d 'di' MMMM 'di' yyyy",
  long: "d 'di' MMMM 'di' yyyy",
  medium: "d 'di' MMM 'di' yyyy",
  short: "d/MM/yyyy"
};
const timeFormats$2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$3 = {
  full: "{{date}} 'na' {{time}}",
  long: "{{date}} 'na' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$3 = {
  date: buildFormatLongFn({
    formats: dateFormats$3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$3,
    defaultWidth: "full"
  })
};
const defaultMonthValues$3 = [
  "Janeru",
  "Fevereru",
  "Marsu",
  "Abril",
  "Maiu",
  "Junhu",
  "Julhu",
  "Agostu",
  "Sitenbru",
  "Otubru",
  "Novenbru",
  "Dizenbru"
];
const abbreviatedMonthValues = [
  "Jan.",
  "Fev.",
  "Marsu",
  "Abril",
  "Maiu",
  "Junhu",
  "Julhu",
  "Ago.",
  "Sit.",
  "Otu.",
  "Nov.",
  "Diz."
];
const monthValues$3 = {
  narrow: abbreviatedMonthValues,
  abbreviated: abbreviatedMonthValues,
  wide: defaultMonthValues$3
};
const defaultDayValues$3 = [
  "Dumingu",
  "Sigunda-fera",
  "Tersa-fera",
  "Kuarta-fera",
  "Kinta-fera",
  "Sesta-fera",
  "Sabadu"
];
const abbreviatedDayValues = ["Dum", "Sig", "Ter", "Kua", "Kin", "Ses", "Sab"];
const dayValues$3 = {
  narrow: abbreviatedDayValues,
  short: abbreviatedDayValues,
  abbreviated: abbreviatedDayValues,
  wide: defaultDayValues$3
};
const defaultDayPeriodValues$3 = {
  am: "di sedu",
  pm: "di tardi",
  midnight: "meia noti",
  noon: "meiu dia",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const abbreviatedDayPeriodValues = {
  ...defaultDayPeriodValues$3,
  am: "SEDU",
  pm: "TARDI"
};
const dayPeriodValues$3 = {
  narrow: abbreviatedDayPeriodValues,
  abbreviated: abbreviatedDayPeriodValues,
  wide: defaultDayPeriodValues$3
};
const defaultFormattingDayPeriodValues$2 = {
  am: "di sedu",
  pm: "di tardi",
  midnight: "meia noti",
  noon: "meiu dia",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const abbreviatedFormattingDayPeriodValues = {
  ...defaultFormattingDayPeriodValues$2,
  am: "SEDU",
  pm: "TARDI"
};
const formattingDayPeriodValues$2 = {
  narrow: abbreviatedFormattingDayPeriodValues,
  abbreviated: abbreviatedFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues$2
};
const localize$3 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$3,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide"
  })
};
const keaLocale = {
  code: "kea",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$3,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$3,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateFormats$2 = {
  full: "EEEE, d MMMM 'ឆ្នាំ' yyyy",
  long: "d MMMM 'ឆ្នាំ' yyyy",
  medium: "d MMM 'ឆ្នាំ' yyyy",
  short: "d/MM/yyyy"
};
const timeFormats$1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$2 = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: "full"
  })
};
const defaultMonthValues$2 = [
  "មករា",
  "កុម្ភៈ",
  "មីនា",
  "មេសា",
  "ឧសភា",
  "មិថុនា",
  "កក្កដា",
  "សីហា",
  "កញ្",
  "តុលា",
  "វិច្ឆិកា",
  "ធ្"
];
const monthValues$2 = {
  narrow: defaultMonthValues$2,
  abbreviated: defaultMonthValues$2,
  wide: defaultMonthValues$2
};
const defaultDayValues$2 = ["អាទិត្យ", "ច័ន្", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្", "សៅរ៍"];
const dayValues$2 = {
  narrow: defaultDayValues$2,
  short: defaultDayValues$2,
  abbreviated: defaultDayValues$2,
  wide: defaultDayValues$2
};
const defaultDayPeriodValues$2 = {
  am: "ព្រឹក",
  pm: "រសៀល",
  midnight: "mi",
  noon: "n",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const dayPeriodValues$2 = {
  narrow: defaultDayPeriodValues$2,
  abbreviated: defaultDayPeriodValues$2,
  wide: defaultDayPeriodValues$2
};
const defaultFormattingDayPeriodValues$1 = {
  am: "ព្រឹក",
  pm: "រសៀល",
  midnight: "mi",
  noon: "n",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const formattingDayPeriodValues$1 = {
  narrow: defaultFormattingDayPeriodValues$1,
  abbreviated: defaultFormattingDayPeriodValues$1,
  wide: defaultFormattingDayPeriodValues$1
};
const localize$2 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
const kmLocale = {
  code: "km",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$2,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$2,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateFormats$1 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/MM/yyyy"
};
const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$1 = {
  full: "{{date}} 'markay saacadu tahay:' {{time}}",
  long: "{{date}} 'markay saacadu tahay:' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const defaultMonthValues$1 = [
  "Janaayo",
  "Febaraayo",
  "Maarso",
  "Abriil",
  "Maayo",
  "Juun",
  "Luuliyo",
  "Agoosto",
  "Sibteembar",
  "Oktoobar",
  "Nufeembar",
  "Diseembar"
];
const monthValues$1 = {
  narrow: defaultMonthValues$1,
  abbreviated: defaultMonthValues$1,
  wide: defaultMonthValues$1
};
const defaultDayValues$1 = ["Axad", "Isniin", "Talaado", "Arbaco", "Khamiis", "Jimce", "Sabti"];
const dayValues$1 = {
  narrow: defaultDayValues$1,
  short: defaultDayValues$1,
  abbreviated: defaultDayValues$1,
  wide: defaultDayValues$1
};
const defaultDayPeriodValues$1 = {
  am: "galinka hore",
  pm: "galinka danbe",
  midnight: "saqdhexe",
  noon: "duhurkii",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const dayPeriodValues$1 = {
  narrow: defaultDayPeriodValues$1,
  abbreviated: defaultDayPeriodValues$1,
  wide: defaultDayPeriodValues$1
};
const defaultFormattingDayPeriodValues = {
  am: "galinka hore",
  pm: "galinka danbe",
  midnight: "saqdhexe",
  noon: "duhurkii",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const formattingDayPeriodValues = {
  narrow: defaultFormattingDayPeriodValues,
  abbreviated: defaultFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues
};
const localize$1 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const soLocale = {
  code: "som",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$1,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$1,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
const dateFormats = {
  full: "EEEE، MMMM d، y",
  long: "MMMM d، y",
  medium: "MMM d، y",
  short: "d/M/yy"
};
const dateTimeFormats = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: enUsLocale.formatLong.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'گزشتہ' eeee p 'بعد دوپہر'",
  yesterday: "'گزشتہ کل' p 'بعد دوپہر'",
  today: "'آج' p 'بعد دوپہر'",
  tomorrow: "'آئندہ کل' p 'بعد دوپہر'",
  nextWeek: "'اگلے' eeee p 'بعد دوپہر'",
  other: "P"
};
const formatRelative = (token) => formatRelativeLocale[token];
const defaultEraValues = ["قبل مسیح", "عیسوی"];
const eraValues = {
  narrow: defaultEraValues,
  abbreviated: defaultEraValues,
  wide: defaultEraValues
};
const defaultMonthValues = [
  "جنوری",
  "فروری",
  "مارچ",
  "اپریل",
  "مئی",
  "جون",
  "جولائی",
  "اگست",
  "ستمبر",
  "اکتوبر",
  "نومبر",
  "دسمبر"
];
const narrowMonthValues = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
const monthValues = {
  narrow: narrowMonthValues,
  abbreviated: defaultMonthValues,
  wide: defaultMonthValues
};
const defaultDayValues = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
const dayValues = {
  narrow: defaultDayValues,
  short: defaultDayValues,
  abbreviated: defaultDayValues,
  wide: defaultDayValues
};
const defaultDayPeriodValues = {
  am: "AM",
  pm: "PM",
  midnight: "آدھی رات",
  morning: "صبح",
  afternoon: "دوپہر",
  evening: "ማታ",
  night: "رات"
};
const dayPeriodValues = {
  narrow: defaultDayPeriodValues,
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues
};
const defaultQuarterValues = ["پہلی سہ ماہی", "دوسری سہ ماہی", "تیسری سہ ماہی", "چوتهی سہ ماہی"];
const narrowQuarterValues = ["1", "2", "3", "4"];
const quarterValues = {
  narrow: narrowQuarterValues,
  abbreviated: defaultQuarterValues,
  wide: defaultQuarterValues
};
const localize = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    formattingValues: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: dayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const urLocale = {
  code: "ur",
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["ENGLISH"] = "en-US";
  Locale2["SPANISH"] = "es-US";
  Locale2["CHINESE_SIMPLIFIED"] = "zh-CN";
  Locale2["CHINESE_TRADITIONAL"] = "zh-hant";
  Locale2["PORTUGUESE"] = "pt-PT";
  Locale2["HAITIAN_CREOLE"] = "ht";
  Locale2["KOREAN"] = "ko";
  Locale2["RUSSIAN"] = "ru-RU";
  Locale2["VIETNAMESE"] = "vi";
  Locale2["ARABIC"] = "ar-SA";
  Locale2["FILIPINO"] = "fil";
  Locale2["SAMOAN"] = "sm";
  Locale2["KHMER"] = "km";
  Locale2["POLISH"] = "pl";
  Locale2["UKRAINIAN"] = "uk";
  Locale2["URDU"] = "ur";
  Locale2["FRENCH"] = "fr";
  Locale2["SOMALI"] = "so";
  Locale2["FARSI"] = "fa";
  Locale2["CAPE_VERDEAN_CREOLE"] = "kea";
  Locale2["AMHARIC"] = "am";
  Locale2["MARSHALLESE"] = "mh";
  Locale2["HMONG"] = "hmn";
  Locale2["HINDI"] = "hi";
  Locale2["HUNGARIAN"] = "hu";
  Locale2["DUTCH"] = "nl";
  return Locale2;
})(Locale || {});
const ALL_LOCALES = Object.values(Locale);
const RIGHT_TO_LEFT_LOCALES = /* @__PURE__ */ new Set();
RIGHT_TO_LEFT_LOCALES.add(
  "ar-SA"
  /* ARABIC */
);
RIGHT_TO_LEFT_LOCALES.add(
  "ur"
  /* URDU */
);
RIGHT_TO_LEFT_LOCALES.add(
  "fa"
  /* FARSI */
);
const DEFAULT_LOCALE = "en-US";
var ExtraLocale = /* @__PURE__ */ ((ExtraLocale2) => {
  ExtraLocale2["AMERICAN_SIGN_LANGUAGE"] = "ase";
  return ExtraLocale2;
})(ExtraLocale || {});
const MOMENT_LOCALE_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh-cn",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "tl-ph",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh-tw",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "pl",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl",
  // locales not supported in moment
  [
    "sm"
    /* SAMOAN */
  ]: "en",
  [
    "so"
    /* SOMALI */
  ]: "en",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "en",
  [
    "am"
    /* AMHARIC */
  ]: "en",
  [
    "mh"
    /* MARSHALLESE */
  ]: "en",
  [
    "hmn"
    /* HMONG */
  ]: "en"
};
const DATE_FNS_LOCALES = {
  [
    "en-US"
    /* ENGLISH */
  ]: enUsLocale,
  [
    "es-US"
    /* SPANISH */
  ]: esLocale,
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: zhCnLocale,
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: ptLocale,
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: htLocale,
  [
    "ko"
    /* KOREAN */
  ]: koLocale,
  [
    "ru-RU"
    /* RUSSIAN */
  ]: ruLocale,
  [
    "vi"
    /* VIETNAMESE */
  ]: viLocale,
  [
    "ar-SA"
    /* ARABIC */
  ]: arLocale,
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: zhTwLocale,
  [
    "pl"
    /* POLISH */
  ]: plLocale,
  [
    "uk"
    /* UKRAINIAN */
  ]: ukLocale,
  [
    "fr"
    /* FRENCH */
  ]: frLocale,
  [
    "fa"
    /* FARSI */
  ]: faIrLocale,
  [
    "hi"
    /* HINDI */
  ]: hiLocale,
  [
    "hu"
    /* HUNGARIAN */
  ]: huLocale,
  [
    "nl"
    /* DUTCH */
  ]: nlLocale,
  // locales not yet supported in date-fns
  [
    "sm"
    /* SAMOAN */
  ]: enUsLocale,
  [
    "mh"
    /* MARSHALLESE */
  ]: enUsLocale,
  [
    "hmn"
    /* HMONG */
  ]: enUsLocale,
  // locales not yet supported in date-fns with custom overrides
  [
    "fil"
    /* FILIPINO */
  ]: filLocale,
  [
    "km"
    /* KHMER */
  ]: kmLocale,
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: keaLocale,
  [
    "so"
    /* SOMALI */
  ]: soLocale,
  [
    "am"
    /* AMHARIC */
  ]: amLocale,
  [
    "ur"
    /* URDU */
  ]: urLocale
};
const LOCALE_DISPLAY_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "English",
  [
    "es-US"
    /* SPANISH */
  ]: "Español",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "简体中文",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "Português",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "Kreyòl Ayisyen",
  [
    "ko"
    /* KOREAN */
  ]: "한국어",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "русский",
  [
    "vi"
    /* VIETNAMESE */
  ]: "Tiếng Việt",
  [
    "ar-SA"
    /* ARABIC */
  ]: "العربية",
  [
    "fil"
    /* FILIPINO */
  ]: "Filipino",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "繁體中文",
  [
    "sm"
    /* SAMOAN */
  ]: "Gagana fa'a Samoa",
  [
    "km"
    /* KHMER */
  ]: "ខ្មែរ",
  [
    "pl"
    /* POLISH */
  ]: "Polski",
  [
    "uk"
    /* UKRAINIAN */
  ]: "українська",
  [
    "ur"
    /* URDU */
  ]: "اُردُو",
  [
    "fr"
    /* FRENCH */
  ]: "Français",
  [
    "fa"
    /* FARSI */
  ]: "فارسی",
  [
    "so"
    /* SOMALI */
  ]: "Soomaali",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "Kriolu",
  [
    "am"
    /* AMHARIC */
  ]: "አማርኛ",
  [
    "mh"
    /* MARSHALLESE */
  ]: "kajin Majöl",
  [
    "hi"
    /* HINDI */
  ]: "हिन्दी",
  [
    "hmn"
    /* HMONG */
  ]: "Hmoob",
  [
    "ase"
    /* AMERICAN_SIGN_LANGUAGE */
  ]: "American Sign Language (ASL)",
  [
    "hu"
    /* HUNGARIAN */
  ]: "Magyar",
  [
    "nl"
    /* DUTCH */
  ]: "Nederlands"
};
const SHORT_LOCALE_DISPLAY_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "EN",
  [
    "es-US"
    /* SPANISH */
  ]: "ES",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "简体中文",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "PT",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "HT",
  [
    "ko"
    /* KOREAN */
  ]: "한국어",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "RU",
  [
    "vi"
    /* VIETNAMESE */
  ]: "VI",
  [
    "ar-SA"
    /* ARABIC */
  ]: "AR",
  [
    "fil"
    /* FILIPINO */
  ]: "KWF",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "繁體中文",
  [
    "sm"
    /* SAMOAN */
  ]: "SM",
  [
    "km"
    /* KHMER */
  ]: "KM",
  [
    "pl"
    /* POLISH */
  ]: "PL",
  [
    "uk"
    /* UKRAINIAN */
  ]: "UK",
  [
    "ur"
    /* URDU */
  ]: "UR",
  [
    "fr"
    /* FRENCH */
  ]: "FR",
  [
    "fa"
    /* FARSI */
  ]: "FA",
  [
    "so"
    /* SOMALI */
  ]: "SO",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "KEA",
  [
    "am"
    /* AMHARIC */
  ]: "AM",
  [
    "mh"
    /* MARSHALLESE */
  ]: "MH",
  [
    "hmn"
    /* HMONG */
  ]: "HMN",
  [
    "hi"
    /* HINDI */
  ]: "HI",
  [
    "hu"
    /* HUNGARIAN */
  ]: "HU",
  [
    "nl"
    /* DUTCH */
  ]: "NL"
};
const LOCALE_ENGLISH_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "English",
  [
    "es-US"
    /* SPANISH */
  ]: "Spanish",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "Simplified Chinese",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "Portuguese",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "Haitian Creole",
  [
    "ko"
    /* KOREAN */
  ]: "Korean",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "Russian",
  [
    "vi"
    /* VIETNAMESE */
  ]: "Vietnamese",
  [
    "ar-SA"
    /* ARABIC */
  ]: "Arabic",
  [
    "fil"
    /* FILIPINO */
  ]: "Filipino",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "Traditional Chinese",
  [
    "sm"
    /* SAMOAN */
  ]: "Samoan",
  [
    "km"
    /* KHMER */
  ]: "Khmer",
  [
    "pl"
    /* POLISH */
  ]: "Polish",
  [
    "uk"
    /* UKRAINIAN */
  ]: "Ukrainian",
  [
    "ur"
    /* URDU */
  ]: "Urdu",
  [
    "fr"
    /* FRENCH */
  ]: "French",
  [
    "fa"
    /* FARSI */
  ]: "Farsi",
  [
    "so"
    /* SOMALI */
  ]: "Somali",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "Cape Verdean Creole",
  [
    "am"
    /* AMHARIC */
  ]: "Amharic",
  [
    "mh"
    /* MARSHALLESE */
  ]: "Marshallese",
  [
    "hmn"
    /* HMONG */
  ]: "Hmong",
  [
    "hi"
    /* HINDI */
  ]: "Hindi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "Hungarian",
  [
    "nl"
    /* DUTCH */
  ]: "Dutch"
};
const FRONTEND_TO_DJANGO_LOCALES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh-hans",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "fil",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh-hant",
  [
    "sm"
    /* SAMOAN */
  ]: "sm",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "pl",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "so"
    /* SOMALI */
  ]: "so",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "kea",
  [
    "am"
    /* AMHARIC */
  ]: "am",
  [
    "mh"
    /* MARSHALLESE */
  ]: "mh",
  [
    "hmn"
    /* HMONG */
  ]: "hmn",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl"
};
const DJANGO_TO_FRONTEND_LOCALES = Object.fromEntries(
  Object.entries(FRONTEND_TO_DJANGO_LOCALES).map(([frontendLocale, djangoLocale]) => [djangoLocale, frontendLocale])
);
var ColorIso639Code = /* @__PURE__ */ ((ColorIso639Code2) => {
  ColorIso639Code2["ENGLISH"] = "en";
  ColorIso639Code2["SPANISH"] = "es";
  ColorIso639Code2["CHINESE_SIMPLIFIED"] = "zh_Hans";
  ColorIso639Code2["CHINESE_TRADITIONAL"] = "zh_Hant";
  ColorIso639Code2["PORTUGUESE"] = "pt";
  ColorIso639Code2["HAITIAN_CREOLE"] = "ht";
  ColorIso639Code2["KOREAN"] = "ko";
  ColorIso639Code2["RUSSIAN"] = "ru";
  ColorIso639Code2["VIETNAMESE"] = "vi";
  ColorIso639Code2["ARABIC"] = "ar";
  ColorIso639Code2["FILIPINO"] = "fil";
  ColorIso639Code2["SAMOAN"] = "sm";
  ColorIso639Code2["KHMER"] = "km";
  ColorIso639Code2["POLISH"] = "pl";
  ColorIso639Code2["UKRAINIAN"] = "uk";
  ColorIso639Code2["URDU"] = "ur";
  ColorIso639Code2["FRENCH"] = "fr";
  ColorIso639Code2["SOMALI"] = "so";
  ColorIso639Code2["FARSI"] = "fa";
  ColorIso639Code2["CAPE_VERDEAN_CREOLE"] = "kea";
  ColorIso639Code2["AMHARIC"] = "am";
  ColorIso639Code2["MARSHALLESE"] = "mh";
  ColorIso639Code2["HMONG"] = "hmn";
  ColorIso639Code2["HINDI"] = "hi";
  ColorIso639Code2["HUNGARIAN"] = "hu";
  ColorIso639Code2["DUTCH"] = "nl";
  return ColorIso639Code2;
})(ColorIso639Code || {});
const COLOR_ISO_639_CODE_BY_LOCALE = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh_Hans",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh_Hant",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "fil",
  [
    "sm"
    /* SAMOAN */
  ]: "sm",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "pl",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "so"
    /* SOMALI */
  ]: "so",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "kea",
  [
    "am"
    /* AMHARIC */
  ]: "am",
  [
    "mh"
    /* MARSHALLESE */
  ]: "mh",
  [
    "hmn"
    /* HMONG */
  ]: "hmn",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl"
  /* DUTCH */
};
const PREFERRED_LOCALE_COOKIE_NAME = "preferredLocale";
function getValidLocale(locale) {
  if (locale.startsWith("en")) {
    return Locale.ENGLISH;
  }
  if (locale.startsWith("es")) {
    return Locale.SPANISH;
  }
  if (locale.startsWith("zh-CN")) {
    return Locale.CHINESE_SIMPLIFIED;
  }
  if (locale.startsWith("pt")) {
    return Locale.PORTUGUESE;
  }
  if (locale.startsWith("ht")) {
    return Locale.HAITIAN_CREOLE;
  }
  if (locale.startsWith("ko")) {
    return Locale.KOREAN;
  }
  if (locale.startsWith("ru")) {
    return Locale.RUSSIAN;
  }
  if (locale.startsWith("vi")) {
    return Locale.VIETNAMESE;
  }
  if (locale.startsWith("ar")) {
    return Locale.ARABIC;
  }
  if (locale.startsWith("fil")) {
    return Locale.FILIPINO;
  }
  if (locale.startsWith("zh-hant")) {
    return Locale.CHINESE_TRADITIONAL;
  }
  if (locale.startsWith("sm")) {
    return Locale.SAMOAN;
  }
  if (locale.startsWith("km")) {
    return Locale.KHMER;
  }
  if (locale.startsWith("pl")) {
    return Locale.POLISH;
  }
  if (locale.startsWith("uk")) {
    return Locale.UKRAINIAN;
  }
  if (locale.startsWith("ur")) {
    return Locale.URDU;
  }
  if (locale.startsWith("kea")) {
    return Locale.CAPE_VERDEAN_CREOLE;
  }
  if (locale.startsWith("fa")) {
    return Locale.FARSI;
  }
  if (locale.startsWith("fr")) {
    return Locale.FRENCH;
  }
  if (locale.startsWith("so")) {
    return Locale.SOMALI;
  }
  if (locale.startsWith("am")) {
    return Locale.AMHARIC;
  }
  if (locale.startsWith("mh")) {
    return Locale.MARSHALLESE;
  }
  if (locale.startsWith("hmn")) {
    return Locale.HMONG;
  }
  if (locale.startsWith("hi")) {
    return Locale.HINDI;
  }
  if (locale.startsWith("hu")) {
    return Locale.HUNGARIAN;
  }
  if (locale.startsWith("nl")) {
    return Locale.DUTCH;
  }
  return null;
}
function setDocumentLangAttribute(validLocale) {
  document.documentElement.setAttribute("lang", validLocale);
}
function getCurrentLocaleFromCookies(cookies) {
  const cookieValue = cookies[PREFERRED_LOCALE_COOKIE_NAME];
  return getValidLocale(cookieValue || navigator.language) || DEFAULT_LOCALE;
}
function usePreferredLocale() {
  const { cookies, setCookie } = useCookiesContext();
  const locale = getCurrentLocaleFromCookies(cookies);
  useEffect(() => {
    setDocumentLangAttribute(locale);
  }, [locale]);
  const setLocale = useCallback(
    (newLocale) => {
      setCookie(PREFERRED_LOCALE_COOKIE_NAME, newLocale, { path: "/" });
    },
    [setCookie]
  );
  const localeIsRightToLeft = useMemo(() => RIGHT_TO_LEFT_LOCALES.has(locale), [locale]);
  return {
    locale,
    setLocale,
    localeIsRightToLeft
  };
}
function useDateFnsLocale() {
  const { locale } = usePreferredLocale();
  return DATE_FNS_LOCALES[locale];
}
function useQueryParamLocale() {
  const { locale, setLocale } = usePreferredLocale();
  const { queryParam, removeQueryParam } = useUrlQueryParam("locale");
  useEffect(() => {
    if (queryParam) {
      removeQueryParam();
      const validLocale = getValidLocale(queryParam);
      if (validLocale && locale !== validLocale) {
        setLocale(validLocale);
      }
    }
  }, [locale, queryParam, removeQueryParam, setLocale]);
}
const sortLocales = (locales) => {
  return locales.sort((locale1, locale2) => {
    const shortLocaleName1 = MOMENT_LOCALE_NAMES[locale1];
    const shortLocaleName2 = MOMENT_LOCALE_NAMES[locale2];
    return shortLocaleName1.localeCompare(shortLocaleName2);
  });
};
function setMockPreferredLocale(locale = DEFAULT_LOCALE) {
  Object.defineProperty(window.document, "cookie", {
    writable: true,
    value: `${PREFERRED_LOCALE_COOKIE_NAME}=${locale}`
  });
}
export {
  ALL_LOCALES as A,
  ColorIso639Code as C,
  DATE_FNS_LOCALES as D,
  ExtraLocale as E,
  FRONTEND_TO_DJANGO_LOCALES as F,
  LOCALE_DISPLAY_NAMES as L,
  MOMENT_LOCALE_NAMES as M,
  PREFERRED_LOCALE_COOKIE_NAME as P,
  RIGHT_TO_LEFT_LOCALES as R,
  SHORT_LOCALE_DISPLAY_NAMES as S,
  getValidLocale as a,
  usePreferredLocale as b,
  useQueryParamLocale as c,
  sortLocales as d,
  DEFAULT_LOCALE as e,
  LOCALE_ENGLISH_NAMES as f,
  getCurrentLocaleFromCookies as g,
  DJANGO_TO_FRONTEND_LOCALES as h,
  Locale as i,
  COLOR_ISO_639_CODE_BY_LOCALE as j,
  setMockPreferredLocale as k,
  setDocumentLangAttribute as s,
  useDateFnsLocale as u
};
//# sourceMappingURL=setMockPreferredLocale-B6noMK-g.js.map
